import { useEffect, useState } from "react"
import axios from "axios"
import api from "../config/backend"
import { toast } from "react-toastify"
import "./css/Invoices.css"
import { SpinnerCircular } from "spinners-react"
import RecurringInvoiceStarter from "../components/RecurringInvoiceStarter"
import CreateRecurringInvoice from "../components/CreateRecurringInvoice"
import RecurringInvoiceList from "../components/RecurringInvoiceList"

const RecurringInvoice = () => {
    const [createInvoice, setCreateInvoice] = useState(false)
    const [invoicesList, setInvoicesList] = useState([])
    const [loading, setLoading] = useState(true)
    const [invoiceUpdatedRefresh, setInvoiceUpdatedRefresh] = useState(0)

    const token = localStorage.getItem("_crm__token")

    const fetchInvoices = async () => {
        const { data, status } = await axios.post(`${api}/Accounting/Recurring/invoices-list`, { token })

        setLoading(false)

        if (data.success) {
            setInvoicesList(data.invoices)
        }
        else {
            toast.error(data.message)
        }
    }

    useEffect(() => {
        fetchInvoices()
    }, [invoiceUpdatedRefresh])

    if (createInvoice) {
        return <CreateRecurringInvoice setCreateInvoice={setCreateInvoice} setInvoiceUpdatedRefresh={setInvoiceUpdatedRefresh} />
    }

    if (loading) {
        return (
            <div className="_5dut">
                <SpinnerCircular size="60" color="#3b70ad" />
            </div>
        )
    }

    if (invoicesList.length) {
        return (
            <RecurringInvoiceList invoicesList={invoicesList} setInvoicesList={setInvoicesList} setCreateInvoice={setCreateInvoice} />
        )
    }

    // New user - no invoices created
    return (
        <RecurringInvoiceStarter setCreateInvoice={setCreateInvoice} />
    )
}

export default RecurringInvoice

